import script from "./ScraperSettingsApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScraperSettingsApp.vue?vue&type=script&setup=true&lang=ts"

import "./ScraperSettingsApp.vue?vue&type=style&index=0&id=d5c7f7ec&lang=css"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"ScraperSettingsApp.vue"]])

export default __exports__